import { Layer, LayersData } from 'saur-viseau-state-management/lib/settings/models/Layers';
import { BasicFilter } from '../screens/ReportingsScreen';

// get active sub layers of a single layer - Layer
export const getActiveLayer = (layer: Layer) => {

    let activeLayers : string[]= []
    if(layer.layers.length){
        layer.layers.forEach(singleLAyer => {
            activeLayers = activeLayers.concat([...getActiveLayer(singleLAyer)])
        });
        if(activeLayers.length){
            activeLayers.push(layer.code)
        }
    } else {
        if(layer.isSelected){
            activeLayers.push(layer.code)
        }
    }
    return activeLayers
}


// get active layers from the root layers data - LayersData
export const getActiveLayers = (layersState: LayersData | null) => {

    const layers = layersState?.layers || [] 
    let activeLayers : string[]= []
   
    layers.forEach(singleLAyer => {
        activeLayers =  activeLayers.concat([...getActiveLayer(singleLAyer)])
    });

    return activeLayers
}

export const sortBy = (array: any[], attribute: string, order: 1 | -1 ) => {
    // order 1 => croissant
    // order -1 => decroissant

    const sortFunc = (a: any, b: any) => {
       
            if (a[attribute] &&  b[attribute] && a[attribute].toLowerCase() < b[attribute].toLowerCase()) {
                return -1 * order;
            }
            if (a[attribute] &&  b[attribute] && a[attribute].toLowerCase() > b[attribute].toLowerCase()) {
                return 1 * order;
            }
            // a must be equal to b
            return 0;
    };
    const localArray = array?.length ? JSON.parse(JSON.stringify(array)) : []
    return localArray.sort(sortFunc);
};


type ReportFilters = {
    tableDim: string;
    columnDim: string;
}
export const constructContractFilter = (contractState: any, historyState: any, filters: ReportFilters[] = []) => {
    const contractFilter: BasicFilter[] = filters.map((filter: ReportFilters) => {
        let values =  {
            table: filter.tableDim,
            column: filter.columnDim,
            values: [] as (string[] | number[])
        }
        if(filter.columnDim === 'INSEECode'){
            values.values = contractState?.selectedContractList
            .flatMap((ct: any) => ct.communes)
            .map((c: any) => c.inseecode)
        } else if(filter.columnDim === 'YearDepth'){
            values.values = Array.from(Array(historyState.yearDisplayLimit + 1).keys())
        } else {
            values.values = contractState?.selectedContractList
            .map((c: any) =>{
              switch (filter.columnDim.toLocaleLowerCase()) {
                case 'contractname':
                    return c.name;
                case 'contractcodename':
                    return c.contractCodeName;
                case 'contract_id_business':
                    return c.partnerContractId;
                case 'contractreference10':
                    return c.contractReference.substring(0,10);
                default:
                    return c[filter.columnDim];
              }
            })
        }
        return values
    })
    return contractFilter
}

export const isSearchValid = (searchFields: any) => {
    
        if(searchFields?.ClientReference && !/^\d{10}$/.test(searchFields.ClientReference )){
            return false;
        }
        
        if(searchFields?.ReferenceFacture && !/^\d{12}$/.test(searchFields.ReferenceFacture )){
            return false;
        }

        if(searchFields?.Mobile && !/^\d{10}$/.test(searchFields.Mobile )){
            return false;
        }

        return true
}

// Detect if browser is Firefox or Safari
export const isFirefoxOrSafari = (): boolean => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isFirefox = userAgent.indexOf('firefox') > -1;
    const isSafari = userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1;
    return isFirefox || isSafari;
}
    